<template>
  <div>
    <slot :question="question"
          :index="index"
          :jump-index="jumpIndex"
          :has-jump="hasJump"></slot>
  </div>
</template>

<script>
import questions from '@views/question-editor/utils/questions'
import jump from '@views/question-editor/utils/jump'
import { Power2, TweenLite } from 'gsap/TweenLite'
import 'gsap/ScrollToPlugin'

export default {
  components: {},
  provide () {
    return {
      SjQuestionItem: this,
    }
  },
  inject: ['SjQuestion'],
  props: {
    prop: Number,
  },
  data () {
    return {}
  },
  computed: {
    index () {
      return this.prop
    },
    question () {
      return this.SjQuestion.questions[this.index]
    },
    hasJump () {
      return jump.hasJump(this.SjQuestion.questions, this.question)
    },
    jumpIndex () {
      return this.question.jumpTargetId && this.SjQuestion.questions.findIndex(({id}) => id === this.question.jumpTargetId)
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    /**
     * 滚动到题目
     */
    scrollIntoView () {
      this.$nextTick(() => {
        TweenLite.to(this.SjQuestion.scrollEl, 0.5, {
          scrollTo: {y: this.$el, offsetY: 15},
          ease: Power2.easeOut,
        })
      })
    },
    /**
     * 移除无效的跳转
     */
    removeInvalidJump (data, index) {
      setTimeout(() => {
        jump.removeInvalid(data, index)
      })
    },
    /**
     * 上移题目
     */
    up (data) {
      questions.up(data, this.index)
      this.removeInvalidJump(data, this.index)
      this.scrollIntoView()
    },
    /**
     * 下移题目
     */
    down (data) {
      // 下一题不是固定题目才能继续操作
      if (data[this.index + 1] && this.SjQuestion.fixedIds.includes(data[this.index + 1].id)) {
        return false
      }
      questions.down(data, this.index)
      this.removeInvalidJump(data, this.index)
      this.scrollIntoView()
    },
    /**
     * 复制题目
     * @param data
     * @param toIndex
     */
    copy (data, toIndex) {
      // 不能复制到固定题目之后
      if (data.length && this.SjQuestion.fixedIds.includes(data[data.length - 1].id)) {
        toIndex = data.length - 1
      }
      // 复制到指定位置
      !Number.isInteger(toIndex) && (toIndex = data.length)
      questions.copy(data, this.index, toIndex)
      jump.removeInvalid(data, toIndex)
    },
    /**
     * 移除题目
     */
    remove (data) {
      questions.removeDependency(data, this.question.id)
      questions.remove(data, this.index)
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question/src/SjQuestionItem.vue